import { React, Styled } from '@common/3rd';
import { DeskComponentRegistry, Widget } from '@component';

export type DeskStepsProps = {
	steps: string[];
	activeIndex: number;
};
export type DeskStepsComponents = {
	Box: any;
};
class DeskSteps<P extends DeskStepsProps,
	S extends { boxWidth: number },
	C extends DeskStepsComponents> extends Widget<P, S, C> {
	boxStepRef: React.RefObject<HTMLDivElement> = React.createRef();
	componentDidMount() {
		super.componentDidMount();
		this.detectButtonCount();
		this.setState({
			boxWidth: document.querySelector('[data-widget=desk-steps]')?.clientWidth || 0
		});
	}

	componentDidUpdate(prevProps: any, prevState?: any, prevContext?: any) {
		super.componentDidUpdate(prevProps, prevState, prevContext);
		this.detectButtonCount();
		const steps = document.querySelector('[data-widget=desk-steps]');
		if (steps && steps.clientWidth && prevState.boxWidth !== steps.clientWidth) {
			this.setState({
				boxWidth: steps.clientWidth
			});
		}
	}

	protected detectButtonCount(): void {
		const box = this.boxStepRef.current;
		if (box != null) {
			box.style.setProperty('--data-children-count', `${box.childElementCount}`);
		}
	}
	protected initComponents(): C {
		return {
			Box: Styled.div.attrs({
				'data-widget': 'desk-steps'
			})`
				${(props: any) => {
					return `
						display: flex;
						flex-direction: row;
						position: relative;
						padding-left: 8vw;
						padding-right: 8vw;
						background-color: ${props.theme.COLOR_PRIMARY_LIGHT_010};

						> div {
							position: relative;
							width: auto;
							padding-left: 12px;
							padding-right: 4px;
							text-align: center;
							display: flex;
							flex-direction: row;

							> span {
								font-weight: ${props.theme.FONT_WEIGHT_BOLD};
								color: ${props.theme.COLOR_WAIVE_LIGHT};
							}
							&:nth-child(-n + ${this.getActiveStepIndex() + 1}) {
								> span {
									color: ${props.theme.COLOR_PRIMARY};
								}
							}
						}
						> div:nth-child(-n + ${this.getActiveStepIndex() + 1}):before {
							padding-right: 20px;
							text-align: center;
							-moz-osx-font-smoothing: grayscale;
							-webkit-font-smoothing: antialiased;
							font-style: normal;
							-webkit-font-feature-settings: normal;
							font-feature-settings: normal;
							font-variant: normal;
							text-rendering: auto;
							width: 1.25em;
							font-family: 'Font Awesome 5 Free';
							font-weight: 900;
							font-size: ${props.theme.FONT_SIZE_SMALL}px;
							color: ${props.theme.COLOR_PRIMARY};
							content: '\f00c';
						}
						> div:not(:last-child):after {
							content: '>';
							padding-left: 20px;
							color: ${props.theme.COLOR_WAIVE_LIGHT};
						}
						`
				}
				}
				${props => this.renderCSS(props.theme)}
			`
		} as C;
	}
	render() {
		const { Box } = this.getComponents();
		return (
			<Box ref={this.boxStepRef}>
				{this.getSteps().map((step: string, index: number) => {
					return (
						<div key={step}>
							<span>{step}</span>
						</div>
					);
				})}
			</Box>
		);
	}
	protected getSteps(): string[] {
		return this.props.steps;
	}
	protected getStepCount(): number {
		return this.getSteps().length;
	}
	protected getActiveStepIndex(): number {
		return this.props.activeIndex;
	}
}

DeskComponentRegistry.register({
	deskSteps: DeskSteps
});

export { DeskSteps };
